import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Eventback from '../../../Component/Eventback'
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';


export default function NAGGLSpringConference() {


    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);


    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>DPA at NAGGL Spring Conference 2025 | SBA Lending Innovation </title>
                <meta name="description" content="Decimal Point Analytics joined NAGGL Spring 2025, showcasing AI-powered SBA lending solutions that enhance efficiency, compliance, and risk management." />
                <meta name="author" content="Decimal Point Analytics" />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/naggl-spring-conference-2025" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>



            <Box id='event-details' className='section sec_bg' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={1} alignItems="top" justifyContent='center'>
                        <Grid item lg={9} md={9} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h2' className='subhead skblue al_center'>
                                    Events
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Decimal Point Analytics <span className='lower'>at</span> NAGGL Spring Conference 2025
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>


                    <Box className='whitebx'>
                        <Typography variant='h6' className='black jst'>
                            Decimal Point Analytics was proud to participate in the <strong>NAGGL Spring Conference 2025,</strong> a key industry event focused on the Small Business Administration (SBA) lending landscape in the United States.
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Representing DPA at the conference was <strong>Nilanjan Das,</strong> Executive Vice President – Strategic Initiatives.
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Key focus areas during discussions included:
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            <ul>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Enhancing underwriting precision through AI and analytics
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Automating SBA loan origination and processing workflows
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Ensuring end-to-end compliance with real-time checks
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Reducing cycle times to accelerate borrower access
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        Leveraging data intelligence to improve portfolio performance
                                    </Typography>
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Nilanjan highlighted how Decimal Point Analytics' SBA-specific solutions are helping financial institutions achieve greater efficiency, reduce risk, and improve outcomes in a complex lending environment.
                        </Typography>

                    </Box>

                    <Eventback />

                </Container >

            </Box >

        </>
    );
}
